// Auto-generated by deployment-compiler. Do not edit.
import { bucketName } from "@atoms/atom-types";

export const MODEL_ASSETS_BUCKET = bucketName("model-assets");
export const POSITION_PREVIEWS_BUCKET = bucketName("position-previews");
export const USER_AVATAR_BUCKET = bucketName("user-avatar");
